import { create } from 'zustand'

interface ServiceStore {
  selectedServiceIds: string[]
  searchQuery: string
  activeCategory: string | null
  toggleService: (id: string) => void
  setSearchQuery: (query: string) => void
  setActiveCategory: (category: string | null) => void
  clearSelection: () => void
}

export const useServiceStore = create<ServiceStore>((set) => ({
  selectedServiceIds: [],
  searchQuery: '',
  activeCategory: null,

  toggleService: (id) =>
    set((state) => ({
      selectedServiceIds: state.selectedServiceIds.includes(id)
        ? state.selectedServiceIds.filter((serviceId) => serviceId !== id)
        : [...state.selectedServiceIds, id],
    })),

  setSearchQuery: (query) => set({ searchQuery: query }),

  setActiveCategory: (category) => set({ activeCategory: category }),

  clearSelection: () => set({ selectedServiceIds: [] }),
}))
